import type { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { Collapsible } from '@/App/tiles/shared/Collapsible';

import { DeltaInput } from './DeltaInput.tsx';

export function FlexiForwardGreeks(): ReactElement {
  const { formatMessage } = useIntl();
  const label = formatMessage({ id: 'flexiForwardTile.collapse.greeks.label' });

  return (
    <Collapsible label={label} id="greeks">
      <DeltaInput />
    </Collapsible>
  );
}
